export default __webpack_public_path__ + "fc8d5e244fbbcae900874258deb152d5.jpg";